// Client-side only: reminder preferences live in localStorage, nothing is sent to the server.
const KEY = "my360boss.vaultReminder";

export const REMINDER_OPTIONS = [
  { key: "off", label: "Off", days: 0 },
  { key: "3d", label: "Every 3 days", days: 3 },
  { key: "weekly", label: "Weekly", days: 7 },
  { key: "biweekly", label: "Every 2 weeks", days: 14 },
];

export function getReminder() {
  try { return JSON.parse(localStorage.getItem(KEY)) || { key: "off", lastLogged: null, lastNotified: null }; }
  catch { return { key: "off", lastLogged: null, lastNotified: null }; }
}

export function setReminder(patch) {
  const next = { ...getReminder(), ...patch };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function markLogged() { return setReminder({ lastLogged: new Date().toISOString(), lastNotified: null }); }

export function reminderDue(r = getReminder()) {
  const opt = REMINDER_OPTIONS.find((o) => o.key === r.key);
  if (!opt || !opt.days) return false;
  const anchor = r.lastLogged ? new Date(r.lastLogged) : new Date(r.enabledAt || 0);
  return Date.now() - anchor.getTime() >= opt.days * 86400000;
}

export async function requestPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  return Notification.requestPermission();
}

export function maybeNotify() {
  const r = getReminder();
  if (!reminderDue(r)) return false;
  const today = new Date().toDateString();
  if (r.lastNotified && new Date(r.lastNotified).toDateString() === today) return false;
  if ("Notification" in window && Notification.permission === "granted") {
    try {
      const n = new Notification("my360boss vault check-in", { body: "Anything new to document this week? A dated note now is worth more than a memory later." });
      n.onclick = () => { window.focus(); window.location.assign("/vault"); };
    } catch { /* ignore */ }
  }
  setReminder({ lastNotified: new Date().toISOString() });
  return true;
}
